var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearnBest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 90,
    viewBox: "0 0 113 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7252 61.875C36.3032 61.875 35.8812 61.9365 35.4787 62.0666C33.1904 62.8066 30.7839 63.2812 28.2502 63.2812C25.7165 63.2812 23.31 62.8066 21.02 62.0666C20.6174 61.9365 20.1972 61.875 19.7752 61.875C8.81779 61.875 -0.0579802 70.7484 0.000285232 81.6715C0.0250039 86.2875 3.83698 90 8.47526 90H48.0252C52.6634 90 56.4754 86.2875 56.5001 81.6715C56.5584 70.7484 47.6826 61.875 36.7252 61.875ZM28.2502 56.25C37.6115 56.25 45.2002 48.6949 45.2002 39.375C45.2002 30.0551 37.6115 22.5 28.2502 22.5C18.8889 22.5 11.3003 30.0551 11.3003 39.375C11.3003 48.6949 18.8889 56.25 28.2502 56.25ZM104.525 0H36.7252C32.0516 0 28.2502 3.91113 28.2502 8.71699V16.875C32.3853 16.875 36.2132 18.0668 39.5502 20.0039V11.25H101.7V61.875H90.4001V50.625H67.8001V61.875H54.339C57.7114 64.8088 60.1868 68.683 61.3468 73.125H104.525C109.199 73.125 113 69.2139 113 64.408V8.71699C113 3.91113 109.199 0 104.525 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnBest);
export default __webpack_public_path__ + "static/media/LearnBest.4dc8dfee66853730264e85231c67e187.svg";
export { ForwardRef as ReactComponent };